// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const integrationCredentialSecretSchema = z.object({
  clientId: z.string(),
  clientSecret: z.string(),
  baseApiUrl: urlSchema,
  scope: z.string().optional(),
});

export const integrationCredentialSchema = z.object({
  id: idSchema,
  url: urlSchema,
  name: z.string(),
  type: z.string(),
  secret: integrationCredentialSecretSchema,
  hooks: z.array(urlSchema),
  organization: urlSchema,
  createdBy: urlSchema,
  createdAt: z.string(),
  modifiedBy: urlSchema.nullable(),
  modifiedAt: z.string().nullable(),
});

export const integrationCredentialTestStatusSchema = z.union([
  z.literal('ok'),
  z.literal('failed'),
]);

export const integrationCredentialTestResultSchema = z.object({
  status: integrationCredentialTestStatusSchema,
  error: z.string().nullable(),
  grantedScopes: z.array(z.string()).nullable(),
  missingScopes: z.array(z.string()).nullable(),
});
